import React, {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from "prop-types";
import IncrementComp from './incrementComp'
//import {updateSettings, updateValues} from '../../../../routers/data'
import {updateValues} from '../../../routers/data'
import {updateSettings, fetchAvailableDates} from '../../../routers/settings'

const min = 0

class formVehicles extends Component{
  static contextTypes = {
    router: PropTypes.object
  }

  handleUpdate = (value) => {
    const values = {...this.props.values, ...value}
    this.props.updateValues(value)
    this.props.fetchAvailableDates(values, this.props.settings)
  }

  render(){
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].fastbooking.vehicles

    const limits = (this.props.settings.limits !== undefined)? this.props.settings.limits: {}
    const {updateSettings} = this.props
    const {nCars, nMotorcycles, nVans, nTowing, nBikes} = this.props.values
    const titleNext = (nCars + nMotorcycles + nVans + nBikes === 0)? langPlace.confirmnovehicles: langPlace.confirmvehicles

    return (
			<div className='container-fluid'>

        <div className='panel-vehicles row'>

            <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
              <IncrementComp name='nCars' value={nCars} min={min} max={limits.maxCars}
                      title={langPlace.cars} subtitle={langPlace.carsdetails} onClick={this.handleUpdate} />
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
              <IncrementComp name='nVans' value={nVans} min={min} max={limits.maxVans}
                      title={langPlace.vans} subtitle={langPlace.vansdetails} onClick={this.handleUpdate} />
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
              <IncrementComp name='nMotorcycles'value={nMotorcycles} min={min} max={limits.maxMotorcycles}
                      title={langPlace.motorcycles} subtitle={langPlace.motorcyclesdetails} onClick={this.handleUpdate} />
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
              <IncrementComp name='nBikes' value={nBikes} min={min} max={limits.maxBikes}
                      title={langPlace.bikes} subtitle={langPlace.bikesdetails} onClick={this.handleUpdate} />
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
              <IncrementComp name='nTowing' value={nTowing} min={min} max={limits.maxTowing}
                      title={langPlace.towings} subtitle={langPlace.towingsdetail} onClick={this.handleUpdate} />
            </div>

        </div>
        <div className='footer row' onClick={() => updateSettings({'tab': 3})}>
          <span className='next'>{titleNext}<i className="fa fa-chevron-circle-right" aria-hidden="true"/></span>
        </div>

		  </div>
    )
  }
}

export default connect(
	(state) => ({settings: state.settings, values: state.data.values}),
  {updateSettings, updateValues, fetchAvailableDates}
)(formVehicles)



// WEBPACK FOOTER //
// ./src/shared/routes/components/fastbooking/panelVehicles.js